module.exports = __webpack_public_path__ + "static/img/环卫车.264ce29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/type-1/环卫车.png
// module id = 4PD9
// module chunks = 0